/* eslint-disable no-console */
import { Wrap } from './styles';

import MultiSelect from './components/MultiSelect';

import Divider from '@material-ui/core/Divider';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useEffect, useState} from 'react';

/**
 * SymbologySwitch
 * 
 * @param {function} onSelect
 * @param {*} disabled
 * @param {array} labelsList
 * @param {boolean} autoSelect
 * @param {object} defaultValue
 * @param {*} props Resto
 * 
 * @returns 
 */
export const SymbologySwitch = ({
  onSelect,
  disabled,
  labelsList,
  autoSelect = true,
  defaultValue,
  ...props
}) => {
  const [labelColumn, setLabelColumn] = useState(null);  

  useEffect(() => {
    if(labelsList.length === 0) {
      setLabelColumn(null);
    }
  }, [labelsList]);

  return (
    <Wrap style={props.style}>
      <h3>Adicione rótulo a camada</h3>
      <Divider />
      <div className="style-list">
        <div className="form-column-field">
          <div className={`field ${disabled ? 'disabled' : ''}`}>
            <MultiSelect
              type="radio"
              placeholder="Selecione o rótulo"
              name="label-column"
              value={labelColumn}
              onChange={(e) => {                
                let onSelectValue;
                e === defaultValue
                  ? onSelectValue = null
                  : onSelectValue = e;
                onSelect(onSelectValue);
                setLabelColumn(e);                
              }}
              data={labelsList}
              defaultValue={defaultValue}
            />
          </div>
        </div>        
      </div>
    </Wrap>
  );
};

SymbologySwitch.properties = {
  ignore: true,
};

export default SymbologySwitch;
